import React, { useEffect } from "react";
import { inject } from "mobx-react";
import { Link, useParams, withRouter } from "react-router-dom";
import withStyles from "react-jss";
import Container from "reactstrap/lib/Container";
import { useQuery } from "@apollo/client";
import { TARIFFS_QUERY_PROVIDER_CARD } from "Services/queries";
import { generateUrl } from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import useDefaultParams from "Services/useDefaultParams";
import PlansBTableContainer from "Containers/PlansBTableContainer";
import BrandButton from "Containers/Buttons/BrandButton";
import Button from "ComponentsUI/Button";
import Block from "ComponentsUI/Block";
import TariffsActualDate from "ComponentsUI/TariffsActualDate";
//TODO Понять, почему нельзя изменять
var Routes = require("Configs/routes");

const styles = (theme) => ({});

const TariffsContainer = (props) => {
	const showTariffHandler = () => {
		let providerModel = props.ApplicationModel.providerModel;
		providerModel.changeTab("provider_tab_tariffs");
	};
	const filter = [];
	const routerParams = useParams();
	const defaultParams = useDefaultParams(routerParams);
	const text = props.ApplicationModel.text;
	const windowSizes = props.ApplicationModel.windowSizeModel.windowSizes;
	let brandButton = props.providerForCard.provider_settings?.brand_button || {};
	if (defaultParams.regionUrl) {
		filter.push(`region.url=${defaultParams.regionUrl}`);
	}
	if (routerParams.providerName) {
		filter.push(`provider.url_name=${routerParams.providerName}`);
	}
	filter.push("provider.mobile_operator=0");

	const tariffsQuery = useQuery(TARIFFS_QUERY_PROVIDER_CARD, {
		variables: {
			filter: filter.join("&"),
			limit: 6,
			sort: "order",
			providerJoin: true,
		},
	});

	let tariffs = tariffsQuery?.data?.tariffs?.data || [];

	useEffect(() => {
		if (!props.providerForCard.vip_provider) {
			sendMetriks("PROVIDER_NE_VIP");
		} else {
			sendMetriks("PROVIDER_VIP");
		}
	}, []);

	useEffect(() => {
		if (!tariffsQuery?.loading) {
			if (!tariffs.length) {
				if (!props.providerForCard.vip_provider) {
					sendMetriks("PROVIDER_NE_VIP_WITHOUT_TARIFF");
				} else {
					sendMetriks("PROVIDER_VIP_WITHOUT_TARIFF");
				}
			}
		}
	}, [tariffsQuery?.loading]);

	if (!tariffs.length) {
		return null;
	}

	let buttonTransparent = true;
	let buttonStatus = "tertiaryAccent";
	let buttonMarginTop = "0px";

	if (!windowSizes.lg) {
		tariffs = tariffs.slice(0, 4);
	}
	if (windowSizes.xs) {
		tariffs = tariffs.slice(0, 4);
		buttonTransparent = false;
		buttonStatus = "purple";
		buttonMarginTop = "20px";
	}

	let providerRatesUrl = generateUrl(Routes.ProviderRates.route, {
		regionUrl: props.match.params.regionUrl,
		providerName: props.match.params.providerName,
	});

	return (
		<Block
			stub={tariffsQuery.loading}
			header={text.menuRates}
			headerWithoutMargin
			brandButton={
				<BrandButton
					brand_button={brandButton}
					click={"prov2"}
					typeBrandButton={"Footer"}
					providerId={props.providerForCard?.id}
				/>
			}
			btn={
				<div style={{ marginTop: buttonMarginTop }}>
					<Button
						stub={tariffsQuery.loading}
						typeText="big"
						component={<Link to={!!providerRatesUrl ? providerRatesUrl : "/"} />}
						onClick={showTariffHandler}
						size={"middle"}
						transparent={buttonTransparent}
						status={buttonStatus}
						datatest="providers_provider_alltariff_button"
						fullWidth={true}
					>
						{text.ALL_RATES}
					</Button>
				</div>
			}
			withoutBottomPadding={true}
		>
			{props?.providerForCard?.update_date && (
				<Container>
					<TariffsActualDate date={props.providerForCard.update_date} />
				</Container>
			)}
			<div className="container" data-test="countRates" data-count={tariffs.length}>
				<PlansBTableContainer
					showNames={true}
					tariffs={tariffs}
					isAboutProvider={true}
					isCard={props.isCard}
					pageName="about_prov"
				/>
			</div>
		</Block>
	);
};

export default withRouter(withStyles(styles)(inject("ApplicationModel")(TariffsContainer)));
